module.exports = __webpack_public_path__ + "img/xialuo.693c2696.jpg";